import { ANGOLAN_IBAN_PREFIX } from '»utils/constants';

export { default as yup } from './yupCustomMethods';

export const isSubmitFormButtonDisabled = ({
  isSubmitting,
  dirty,
  errors,
  values,
  areFiles,
}) => {
  const checkIfFieldsAreFilled = () => {
    if (areFiles)
      return Object.values(values).some((file) =>
        Object.entries(file).some(
          ([fieldName, value]) =>
            (fieldName === 'file' ||
              fieldName === 'documentNumber' ||
              fieldName === 'lifetime' ||
              fieldName === 'expirationDate' ||
              fieldName === 'validated') &&
            !!value,
        ),
      );

    if (Array.isArray(values))
      return values.some((element) =>
        Object.values(element).some(
          (elementValue) => elementValue !== '' || elementValue.length !== 0,
        ),
      );

    return Object.values(values).some(
      (value) => value !== '' || value.length !== 0,
    );
  };

  return (
    isSubmitting ||
    (!dirty && !checkIfFieldsAreFilled()) ||
    Object.keys(errors).length > 0
  );
};

const removeSpacesFromField = (value = '') => value.replace(/\s+/g, '');

export const normalizeFieldWithoutSpaces =
  ({ fieldName, setFieldValue }) =>
  (event) => {
    const valueWithoutSpaces = removeSpacesFromField(event.target.value);

    if (valueWithoutSpaces !== event.target.value) {
      setFieldValue(fieldName, valueWithoutSpaces);
    }
  };

const ensureAngolanIbanPrefix = (value = '') => {
  const normalizedValue = value.toUpperCase();

  if (!normalizedValue) return ANGOLAN_IBAN_PREFIX;
  if (normalizedValue.startsWith(ANGOLAN_IBAN_PREFIX)) return normalizedValue;

  const valueWithoutPrefix = normalizedValue.replace(/^AO0?6?/, '');

  return ANGOLAN_IBAN_PREFIX + valueWithoutPrefix;
};

export const normalizeIbanWithAngolanPrefix =
  ({ fieldName, setFieldValue }) =>
  (event) => {
    const valueWithoutSpaces = removeSpacesFromField(event.target.value);
    const valueWithPrefix = ensureAngolanIbanPrefix(valueWithoutSpaces);

    if (valueWithPrefix !== event.target.value) {
      setFieldValue(fieldName, valueWithPrefix);
    }
  };
